export default {
  // None
  None: 0,

  // Sao lưu
  Backuping: 1,

  // Phục hồi
  Restoring: 2,

  // Bảo trì
  Maintaning: 3,

  // Tạo dữ liệu từ năm trước
  CreateDataPrevYear: 4
};
